import React from 'react'
import PropTypes from 'prop-types'
import DefaultAvatar from 'src/assets/img/house/default_avatar.png'
import RankProfileCard from 'src/components/house/RankProfilecard'
import LikeProfileCard from 'src/components/house/LikeProfileCard'
import { EditProfileButton } from 'src/components/house/EditProfileButton'

const UserProfileCard = ({
  user,
  onProfileClick,
  onAvatarClick,
  rank,
  showEditButton = true,
  isListUser = false
}) => {
  const handleAvatarClick = (e) => {
    e.stopPropagation()
    if (onAvatarClick) {
      onAvatarClick()
    } else if (onProfileClick) {
      onProfileClick()
    }
  }

  return (
    <div
      className={`cursor-pointer relative flex w-full items-center justify-end gap-1 rounded-full pl-3 text-white h-14 xs:h-16 xs:pl-4 ${
        isListUser ? 'bg-midnight-blue' : 'bg-midnight-blue/40'
      }`}
      onClick={handleAvatarClick}
    >
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <div className="w-full truncate text-right text-xs font-medium xs:text-sm">
          {user?.house_name || user?.name || 'ユーザーネーム'}
        </div>
        <div className="flex items-center justify-end gap-[2px] xs:gap-1">
          <RankProfileCard type={rank} />
          <LikeProfileCard like={user?.like_count?.toLocaleString()} />
        </div>
      </div>

      <div className="relative shrink-0">
        <div
          className="w-16 h-16 xs:w-20 xs:h-20 rounded-full overflow-hidden border-2 border-stone-gray bg-white cursor-pointer bg-[center_top_-12px] bg-[length:180%_180%] bg-no-repeat"
          style={{ backgroundImage: `url(${user?.icon_url || DefaultAvatar})` }}
        >
          {showEditButton && <EditProfileButton onClick={onProfileClick} />}
        </div>
      </div>
    </div>
  )
}

UserProfileCard.propTypes = {
  user: PropTypes.shape({
    house_name: PropTypes.string,
    name: PropTypes.string,
    icon_url: PropTypes.string,
    like_count: PropTypes.number,
    possession_heart: PropTypes.number
  }),
  onProfileClick: PropTypes.func,
  onAvatarClick: PropTypes.func,
  rank: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showEditButton: PropTypes.bool,
  isListUser: PropTypes.bool
}

export default UserProfileCard
